export const warningTypeMap = [
  { value: 1, label: '超2小时工单未分配' },
  { value: 2, label: '超3次工单未处理' }
]
